module.exports = __webpack_public_path__ + "media/images/ic-seta-direita-9752d4d1b4f8660c650395d3d78e0c69.svg";